var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfinity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.83052 11.8852L8.15162 12.6516C7.62718 13.176 6.95899 13.5332 6.23156 13.6779C5.50412 13.8226 4.75011 13.7484 4.06487 13.4646C3.37964 13.1808 2.79395 12.7001 2.38188 12.0834C1.96982 11.4667 1.74988 10.7417 1.74988 10C1.74988 9.25831 1.96982 8.53328 2.38188 7.91659C2.79395 7.2999 3.37964 6.81925 4.06487 6.53543C4.75011 6.25161 5.50412 6.17736 6.23156 6.32208C6.95899 6.46679 7.62718 6.82397 8.15162 7.34844L12.8485 12.6516C13.3729 13.176 14.0411 13.5332 14.7686 13.6779C15.496 13.8226 16.25 13.7484 16.9352 13.4646C17.6205 13.1808 18.2062 12.7001 18.6182 12.0834C19.0303 11.4667 19.2502 10.7417 19.2502 10C19.2502 9.25831 19.0303 8.53328 18.6182 7.91659C18.2062 7.2999 17.6205 6.81925 16.9352 6.53543C16.25 6.25161 15.496 6.17736 14.7686 6.32208C14.0411 6.46679 13.3729 6.82397 12.8485 7.34844L12.1696 8.11485",
    stroke: "#7B7B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfinity);
export default __webpack_public_path__ + "static/media/infinity.0044064c5d24f18cba396c3359a35d4f.svg";
export { ForwardRef as ReactComponent };